import type { Product } from '../../core/types/catalog'

export const HOME_BESTSELLERS = 4
/** Zoveel flesjes op de plank van de homepage (schuifbaar). */
export const HOME_SHELF = 8
export const HOME_ARTICLES = 3
/** Zoveel producten staan er in het Thuis-paneel bij Kiezen; de rest als "+ n meer". */
export const CONCERN_ITEMS = 4
/** Zoveel producten onder het hoofdartikel in het journal-blok. */
export const JOURNAL_PRODUCTS = 3

/** Bestsellers en salonfavorieten. Puur. */
export function homeBestsellers(products: readonly Product[], count = HOME_BESTSELLERS): Product[] {
  return products.filter((p) => p.bestseller || p.salonFavourite).slice(0, count)
}

/**
 * Een vaste lijst van hoogstens `max` regels, zodat alle panelen bij Kiezen even hoog zijn.
 * Past alles net niet (één over), dan tonen we die ook: "+ 1 meer" kost evenveel ruimte. Puur.
 */
export function capList<T>(items: readonly T[], max = CONCERN_ITEMS): { shown: T[]; more: number } {
  if (items.length <= max + 1) return { shown: [...items], more: 0 }
  return { shown: items.slice(0, max), more: items.length - max }
}
